import React from 'react';
import { compose } from 'recompose';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import config from '../../../config';
import ReminderForm from './ReminderForm';
import { format } from 'date-fns';

class EditReminderForm extends ReminderForm {
  initState() {
    const reminder = this.props.reminder;
    const userReminderType = this.props.reminderTypes.find((reminderType) => reminderType.id === reminder.user_reminder_type_id);
    this.state = {
      isRecurring: reminder.is_recurring,
      reminderDate: reminder.original_date,
      selectedUserReminderType: userReminderType,
      selectedUserReminderTypeOption: reminder.user_reminder_type_option_id,
      title: reminder.title,
    };
  }

  bind() {
    super.bind();
    this.deleteRemider = this.deleteRemider.bind(this);
  }

  getParamsFromState() {
    const selectedType = this.state.selectedUserReminderType;
    const params = {
      user_reminder_type_id: selectedType.id,
      title: this.state.title,
      reminder_date: format(this.state.reminderDate, 'YYYY-MM-DD'),
    };
    if (selectedType.code === 'birthday') {
      params.user_reminder_type_option_id = this.state.selectedUserReminderTypeOption;
    }
    if (selectedType.code === 'others') {
      params.is_recurring = this.state.isRecurring;
    }
    return params;
  }

  deleteRemider(e) {
    e.preventDefault();
    $.ajax({
      url: `${config.localeApi}/reminders/${this.props.reminder.user_reminder_id}`,
      type: 'DELETE',
    })
    .done(() => {
      toastr.success(
        this.props.t('account.dashboard_remind_me_deleted_successfully', 'Reminder deleted successfully'),
      );
    })
    .fail((error) => {
      let errorMessage = this.props.parseError(error.responseJSON.errors);
      if (error.status === 404) {
        errorMessage = this.props.t('account.dashboard_remind_me_reminder_already_deleted', 'Reminder already deleted.');
      }
      if (!errorMessage) {
        errorMessage = this.props.t('account.dashboard_remind_me_deleting_failed', 'Something went wrong, please reload later.');
      }
      toastr.error(errorMessage)
    })
    .always(() => {
      this.props.refreshList();
      this.props.onDelete();
    })
    return false;
  }

  modalHeader() {
    return <div className="modal-header">
      <h3 className="font-weight-bold">
        <HTMLTrans id='account.dasboard_reminder_modal_header_edit_reminder'>Edit Reminder</HTMLTrans>
      </h3>
      {this.closeButton()}
    </div>
  }

  actionButtons() {
    return <div className="modal-reminder-edit-save-row">
      <button
        type="button"
        className='modal-reminder-delete-button'
        onClick={this.deleteRemider}
      >
        <HTMLTrans id='account.dasboard_reminder_modal_delete'>Delete Date</HTMLTrans>
      </button>

      <button
        type="button"
        className="btn btn-primary"
        onClick={this.submitReminder}
        disabled={!this.isValid()}
      >
        <HTMLTrans id='account.dasboard_reminder_modal_save'>Save</HTMLTrans>
      </button>
    </div>
  }
}

const enhance = compose(withTranslationProvider);
export default enhance(EditReminderForm);
export const undecorated = EditReminderForm;


// WEBPACK FOOTER //
// ./src/Account/RemindMe/EditReminderForm.js